import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {deleteAccountError, deleteAccountSuccess} from "features/modals/delete-account/reducer";
export function* deleteAccountSaga() {
    try {
        yield call([api, api.deleteAccountApi]);
        yield put(deleteAccountSuccess());
    } catch (e) {
        yield put(deleteAccountError(getErrorFromMessage(e)))
    }
}